module.exports = __webpack_public_path__ + "img/empty-poll.6133dc5f.svg";